export default "{\n    \"title\": \"Solicitar servicio del proveedor\",\n    \"subtitle\": \"Crear y enviar órdenes de trabajo a proveedores\"\n}\n"